export default __webpack_public_path__ + "static/news28-cafe8c59e7840c911f79e1182547857d.png";